(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["decor-product-reassurance"] && !Shopify.designMode) return;
  try {
    class DecorProductTrust extends HTMLElement {
    connectedCallback() {
      const container = this.parentElement;
      const buyButtons = container && container.querySelector('.buy-buttons-block');
      if (buyButtons && buyButtons.nextElementSibling !== this) {
        buyButtons.insertAdjacentElement('afterend', this);
      }
    }
  }

  if (!customElements.get('decor-product-trust')) {
    customElements.define('decor-product-trust', DecorProductTrust);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gta-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gtaDeliveryInit) return;
    window.__gtaDeliveryInit = true;

    var FREE_FSAS = [
      'L4T','L4V','L4W','L4X','L4Y','L4Z','L5A','L5B','L5C','L5E','L5G','L5H','L5J','L5K','L5L','L5M','L5N','L5P','L5R','L5S','L5T','L5V','L5W',
      'L6P','L6R','L6S','L6T','L6V','L6W','L6X','L6Y','L6Z','L7A',
      'L6H','L6J','L6K','L6L','L6M',
      'L7L','L7M','L7N','L7P','L7R','L7S','L7T',
      'L9T','L9E',
      'L8B','L8E','L8G','L8H','L8J','L8K','L8L','L8M','L8N','L8P','L8R','L8S','L8T','L8V','L8W','L9A','L9B','L9C','L9G','L9H','L9K',
      'N3W',
      'L2M','L2N','L2P','L2R','L2S','L2T','L2W','L2V',
      'L3M',
      'L2E','L2G','L2H','L2J',
      'L3B','L3C',
      'N1C','N1E','N1G','N1H','N1K','N1L',
      'N3P','N3R','N3S','N3T','N3V',
      'N2A','N2B','N2C','N2E','N2G','N2H','N2M','N2N','N2P','N2R',
      'N2J','N2K','N2L','N2T','N2V',
      'N1P','N1R','N1S','N1T','N3C','N3E','N3H',
      'L4H','L4J','L4K','L4L','L6A',
      'L4B','L4C','L4E','L4S',
      'L3P','L3R','L3S','L3T','L6B','L6C','L6E','L6G',
      'L1V','L1W','L1X','L1Y',
      'L1S','L1T','L1Z',
      'L1M','L1N','L1P','L1R',
      'L1G','L1H','L1J','L1K','L1L'
    ];
    var FREE = {};
    FREE_FSAS.forEach(function (f) { FREE[f] = true; });

    var POSTAL_RE = /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][0-9][ABCEGHJ-NPRSTV-Z][0-9]$/;
    var STORAGE_KEY = 'decor_postal_code';

    function normalize(value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    function money(cents) {
      var s = (cents / 100).toFixed(2);
      if (s.slice(-3) === '.00') s = s.slice(0, -3);
      return '$' + s;
    }

    function isFreeArea(code) {
      return code.charAt(0) === 'M' || code.slice(0, 5) === 'L0R2H' || FREE[code.slice(0, 3)] === true;
    }

    function isHamilton(code) { var h = ['L8B','L8E','L8G','L8H','L8J','L8K','L8L','L8M','L8N','L8P','L8R','L8S','L8T','L8V','L8W','L9A','L9B','L9C','L9G','L9H','L9K','N3W','N3P','N3R','N3S','N3T','N3V','N1C','N1E','N1G','N1H','N1K','N1L']; return code.slice(0, 5) === 'L0R2H' || h.indexOf(code.slice(0, 3)) !== -1; } function isOntario(code) {
      return 'KLMNP'.indexOf(code.charAt(0)) !== -1;
    }

    function messageFor(root, code) {
      var context = root.getAttribute('data-context');
      var threshold = Number(root.getAttribute('data-threshold')) || 89900;
      var total = Number(root.getAttribute('data-total')) || 0;

      if (!POSTAL_RE.test(code)) return 'Please enter a valid Canadian postal code, like L8N 1A1.';
      if (!isOntario(code)) return 'We currently deliver within Ontario only.';

      var pretty = code.slice(0, 3) + ' ' + code.slice(3);

      if (isFreeArea(code)) {
        if (context === 'cart' && total > 0) {
          if (total >= threshold) return 'Free delivery applies to your order for ' + pretty + '.';
          return 'Delivery to ' + pretty + ' is ' + (isHamilton(code) ? '$49' : '$79') + ', or free once your order reaches ' + money(threshold) + '. Add ' + money(threshold - total) + ' more to unlock free delivery.';
        }
        return 'Good news: delivery to ' + pretty + ' is ' + (isHamilton(code) ? '$49' : '$79') + ', and free on orders of ' + money(threshold) + ' or more.';
      }

      if (code.charAt(0) === 'P') return 'Delivery to ' + pretty + ' is $150 at checkout, or $99 on orders of $899 or more. Northern Ontario delivery costs vary, so we confirm your rate after you order and will contact you with a quote first if it is higher.';
      return 'Delivery to ' + pretty + ' is $150, or $99 on orders of $899 or more.';
    }

    function render(root, code) {
      var out = root.querySelector('[data-gta-result]');
      if (out) out.textContent = messageFor(root, code);
    }

    function save(code) {
      try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
    }

    function load() {
      try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
    }

    function check(root) {
      var input = root.querySelector('[data-gta-input]');
      var code = normalize(input && input.value);
      render(root, code);
      if (POSTAL_RE.test(code)) save(code);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-gta-check]');
      if (!button) return;
      var root = button.closest('[data-gta-delivery]');
      if (root) check(root);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest && event.target.closest('[data-gta-input]');
      if (!input) return;
      event.preventDefault();
      var root = input.closest('[data-gta-delivery]');
      if (root) check(root);
    });

    function prefill() {
      var saved = load();
      if (!saved || !POSTAL_RE.test(saved)) return;
      document.querySelectorAll('[data-gta-delivery]').forEach(function (root) {
        var input = root.querySelector('[data-gta-input]');
        if (input && !input.value) {
          input.value = saved.slice(0, 3) + ' ' + saved.slice(3);
          render(root, saved);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prefill);
    } else {
      prefill();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
